import { ModelHelper } from '../classes/model-helper';
import { SignatureFileData } from './signature-file-data.model';

/**
 * Signature file data
 */
export class SignatureData {
	signatureFile: SignatureFileData;
	signatureText: string;
	useSignature: boolean;

	/**
	 * Static mapping function
	 *
	 * @param data
	 * @param item
	 * @returns SignatureData
	 */
	static map(data: any, item: SignatureData = new SignatureData()): SignatureData {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 *
	 * @param data
	 * @return SignatureData
	 */
	public map(data: any): SignatureData {
		ModelHelper.map(data, this, 'signatureFile', SignatureFileData);
		ModelHelper.map(data, this, 'signatureText');
		ModelHelper.map(data, this, 'useSignature');

		return this;
	}

	/**
	 * Prepare company data for api
	 *
	 * @param data
	 */
	public getDataForApi(data: any = this): any {
		// Clone data
		let apiData: any = SignatureData.map(JSON.parse(JSON.stringify(data)));

		// Process properties
		for (const [key, value] of Object.entries(apiData)) {
			// Check for own getDataForApi method
			if (value && (<any>value).getDataForApi) {
				apiData[key] = (<any>value).getDataForApi();
			} else {
				apiData[key] = JSON.parse(JSON.stringify(value));
			}
		}

		// Reduce api data to original properties of data
		apiData = ModelHelper.intersection(JSON.parse(JSON.stringify(data)), apiData);

		// Signature file id
		if (apiData.signatureFile || apiData.signatureFile === null) {
			apiData.signatureFileId = apiData.signatureFile;
			delete apiData.signatureFile;
		}

		// Return data for api
		return apiData;
	}
}
